//
// CASManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./Voucher";

var CASManager = createModule("transport::CASManager", ["transport::SubserviceManager"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getTableSummaryStatistics: [1,1],
        getColumnFrequency: [1,1],
        getTable: [1,7,7,7],
        expandLibrary: [1,1],
        getColumnSummaryStatistics: [1,1],
        getServers: [1],
        getColumnDistinctValues: [1,1],
        expandServer: [1,1],
        expandTable: [1,1],
        canUpload: [2,1,7],
        getTableDistinctCounts: [1,1],
        uploadFileToTable: [1,1],
    },
    ,
    ,
]);
export default CASManager;
